'use client';

import { usePageBackButton } from './use-page-back-button';

interface PageWithBackButtonProps {
  children: React.ReactNode;
  fallbackUrl?: string;
}

export function PageWithBackButton({ children, fallbackUrl }: PageWithBackButtonProps) {
  usePageBackButton({ fallbackUrl });
  return <>{children}</>;
}
